<template>
  <span>
    <span class="float-right"> <select-scale size="md"></select-scale></span>
    <b-button v-b-modal="'modalLote'" @click="resetDetailForm"> Agregar lote</b-button>

    <b-spinner v-if="loading" variant="primary" class="ml-2 mt-1" small label="Small Spinner"></b-spinner>
    <!-- Modal Component -->
    <b-modal
      id="modalLote"
      title="Agregar lote"
      @cancel="resetDetailForm"
      @ok="submit"
      :ok-disabled="loading"
      @show="$v.$reset()"
      @shown="getCompanyFacilities(company)"
      ref="modal"
    >
      <b-row>
        <b-col lg="12">
          <b-form-group label="Producto">
            <b-form-select
              id="product"
              @change="getProductSet"
              :state="$v.contentData.product.$dirty ? !$v.contentData.product.$error : null"
              v-model="$v.contentData.product.$model"
              :options="products"
            />
          </b-form-group>

          <b-form-group label="Tipo de producto" label-for="processTypeSelect">
            <b-form-select
              id="processTypeSelect"
              @change="changeTipoProducto($event)"
              :disabled="contentData.id ? true : false"
              :state="$v.contentData.product_type.$dirty ? !$v.contentData.product_type.$error : null"
              v-model="$v.contentData.product_type.$model"
              value="Seleccione..."
            >
              <option
                v-for="product_type in productSet.product_types"
                v-bind:value="{
                  id: product_type.value,
                  text: product_type.text,
                  exportable: product_type.exportable
                }"
              >
                {{ product_type.text }}
              </option>
            </b-form-select>
          </b-form-group>

          <b-form-group label="Variedad" label-for="basicSelect">
            <b-form-select
              id="varietySelect"
              :state="$v.contentData.variety.$dirty ? !$v.contentData.variety.$error : null"
              v-model="$v.contentData.variety.$model"
              :options="productSet.varieties"
              :disabled="!product"
            >
            </b-form-select>
          </b-form-group>

          <b-form-group label="Huerto (CSG)" label-for="basicSelect">
            <b-form-select
              id="originSelect"
              :state="$v.contentData.origin.$dirty ? !$v.contentData.origin.$error : null"
              v-model="$v.contentData.origin.$model"
              :options="companyFacilities.origins"
              value="Seleccione..."
            >
            </b-form-select>
          </b-form-group>

          <b-form-group label="Condicion" label-for="basicSelect">
            <b-form-select
              id="conditionSelect"
              :state="$v.contentData.condition.$dirty ? !$v.contentData.condition.$error : null"
              v-model="$v.contentData.condition.$model"
              :options="conditions"
              value-field="name"
              text-field="name"
              :disabled="!origin"
            >
            </b-form-select>
          </b-form-group>
          <custom-fields :form="contentData.custom_fields" :input_group="productSet.lot_custom_fields"></custom-fields>
          <b-form-group
            label="Certificados"
            class="pt-1"
            v-if="$store.state.user.scope.includes('mostrar-certificaciones-en-modal-lote')"
          >
            <ul v-for="certificate in certificates" :key="certificate">
              <li>{{ labelize(certificate.split(":")[0]) }}: {{ certificate.split(":")[1] }}</li>
            </ul>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </span>
</template>

<script>
import { decimal, integer, minValue, required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { bus } from "../../main";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import Vue from "vue";
import CustomFields from "@/views/recepcion/CustomFields";
import selectScale from "../reusable/selectScale";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

Vue.use(VueNotifications);
Vue.use(miniToastr);

export default {
  name: "ModalLote",
  components: { CustomFields, selectScale },
  // This props are receiving the data from the parent component
  props: ["company", "client_customer", "waybillID", "formModal", "waybillDATE"],
  data() {
    return {
      loading: false,
      modalTitle: "Agregar detalles",
      editing_modal: false,
      contentData: {
        id: null,
        product: "",
        variety: null,
        condition: "",
        origin: null,
        product_type: null,
        custom_fields: {}
      },
      productSet: {
        product_types: [],
        varieties: [],
        lot_custom_fields: {}
      },
      companyFacilities: [],
      products: [],
      conditions: [],
      certificates: []
    };
  },
  validations: {
    contentData: {
      product: { required },
      variety: { required },
      origin: { required },
      product_type: { required },
      condition: { required }
    }
  },
  mounted() {
    bus.$on("lotEdit", (data) => {
      this.contentData.product = data.product;
      this.contentData.id = data.id;
      this.getProductSet(data.product);
      this.contentData.variety = data.variety;
      this.contentData.condition = data.condition;
      this.contentData.origin = data.origin;
      this.contentData.custom_fields = data.custom_fields;
      this.contentData.product_type = {
        id: data.product_type,
        text: data.product_type_name,
        exportable: /true/i.test(data.exportable)
      };
      this.$nextTick(() => {
        this.$refs.modal.show();
      });
      this.$v.$touch();
    });
  },
  computed: {
    origin() {
      return this.contentData.origin;
    },
    product() {
      return this.contentData.product;
    }
  },
  watch: {
    origin(new_value, old_value) {
      if (new_value) {
        this.getOriginConditions(new_value);
      }
    }
  },
  methods: {
    labelize(text) {
      // tranquilidad_establecida
      return text
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
    getOriginConditions(val) {
      this.$axios
        .get(`/api/v1/origin/${val}/?expand=conditions`)
        .then((res) => {
          this.conditions = res.data.conditions;
          this.certificates = res.data.certificates;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    resetDetailForm() {
      this.contentData.id = null;
      this.contentData.origin = null;
      this.contentData.product = null;
      this.contentData.variety = null;
      this.contentData.condition = null;
      this.contentData.product_type = null;
      this.contentData.custom_fields = {};
      this.productSet = {
        product_types: [],
        varieties: [],
        lot_custom_fields: {}
      };
    },

    // ******** Getting variables based on selections

    getProducts() {
      this.$axios
        .get("/production/get_products/")
        .then((res) => {
          const data = res.data.data;
          const products = [];
          for (let key in data) {
            const product = data[key];
            products.push(product);
          }
          this.products = products;
        })
        .catch((error) => console.log(error));
    },

    getCompanyFacilities(a) {
      this.$axios
        .get("/production/get_company_facilities/" + a)
        .then((res) => {
          this.companyFacilities = res.data;
          //this.contentData.origin = this.companyFacilities.origins[0].value;
        })
        .catch((error) => console.log(error));
    },

    async getProductSet(a) {
      const thisV = this;
      thisV.loading = true;
      thisV.productSet.product_types = [{ value: null, text: "Cargando..." }];
      thisV.productSet.varieties = [{ value: null, text: "Cargando..." }];
      try {
        const res = await thisV.$axios.get("/production/get_product_set/" + a);
        thisV.productSet.spec_type = res.data.spec_type;
        thisV.productSet.varieties = res.data.varieties;
        thisV.productSet.lot_custom_fields = res.data.lot_custom_fields;
        const items = [];
        for (let key in res.data.product_types) {
          if (res.data.product_types[key].waste == false) {
            items.push(res.data.product_types[key]);
          }
        }
        thisV.productSet.product_types = items;
        thisV.loading = false;
      } catch (error) {
        thisV.loading = false;
        console.log(error);
      }
    },

    // ********  End getting variables based on selections

    submit: function (evt) {
      this.$v.$touch();
      if (this.$v.$invalid) {
        evt.preventDefault();
        this.$emit("validate", false);
      } else {
        this.$emit("validate", true);
        if (this.contentData.id === null) {
          this.$nextTick(() => {
            this.$refs.modal.hide();
          });
          this.createLot();
        } else {
          this.updateContent(this.contentData.id);
        }
        this.resetDetailForm();
      }
    },

    createLot() {
      const data = {
        waybill: this.waybillID,
        origin: this.contentData.origin,
        product_type: this.contentData.product_type.id,
        condition: this.contentData.condition,
        variety: this.contentData.variety,
        custom_fields: this.contentData.custom_fields
      };
      this.loading = true;
      this.$axios
        .post("/api/v1/lot/", data)
        .then((res) => {
          this.loading = false;
          this.resetDetailForm();
          this.$emit("refreshContents", this.waybillID);
          miniToastr.success("Operación realizada con éxito", "");
        })
        .catch((error) => {
          this.loading = false;
          miniToastr.error("Ha ocurrido un error", "");
          console.log(error.response);
        });
    },

    updateContent(a) {
      const data = {
        id: this.contentData.id,
        waybill: this.waybillID,
        origin: this.contentData.origin,
        product_type: this.contentData.product_type.id,
        condition: this.contentData.condition,
        variety: this.contentData.variety,
        custom_fields: this.contentData.custom_fields
      };
      this.loading = true;
      this.$axios
        .put("/api/v1/lot/" + a + "/", data)
        .then((res) => {
          this.loading = false;
          this.resetDetailForm();
          this.$emit("refreshContents", this.waybillID);
          miniToastr.success("Operación realizada con éxito", "");
        })
        .catch((error) => console.log(error));
    }
  },
  beforeMount() {
    this.getProducts();
  }
};
</script>
